<template>
    <v-card>
        <v-card-title>
            <span class="text-h5 mobile-text-f16">Please select your activity:</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('modal-close')"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-container class="p-4">
            <v-row class="mb-8">
                <v-radio-group column v-model="single_day_type">
                    <template v-if="module_type_enabled && module_type == 'module_9'">
                        <v-radio value="afternoon" label="1/2 Day"></v-radio>
                        <v-radio value="night" label="Night Skiing"></v-radio>
                    </template>
                    <template v-if="module_type_enabled && (module_type !== 'module_9' && module_type=='module_6')">
                        <v-radio value="day_hours" label="Day Skiing"></v-radio>
                        <v-radio value="night_hours" label="Night Skiing"></v-radio>
                    </template>
                    <template v-if="frontend_view_folder === 'frontend.skigd'">
                        <v-radio value="afternoon" label="Afternoon"></v-radio>
                        <v-radio value="night" label="Night"></v-radio>
                    </template>
                    <template v-if="module_type_enabled && module_type == 'module_12'">
                        <v-radio value="daily" label="Daily"></v-radio>
                        <v-radio value="morning" label="Morning 1/2 Day (9 AM - 1 PM)"></v-radio>
                        <v-radio value="afternoon" label="Afternoon 1/2 Day (9 AM - 1 PM)"></v-radio>
                        <v-radio value="twilight" label="Twilight (1 PM - Close)"></v-radio>
                        <v-radio value="night" label="Night (5 PM - Close)"></v-radio>
                        <v-radio value="beech_pass" label="Beech Pass (9AM - Close)"></v-radio>
                    </template>
                </v-radio-group>
            </v-row>
            <v-row class="mt-8 mb-3 justify-content-end">
                <v-btn color="primary" text @click="Next" :disabled="(!module_type_enabled || (module_type_enabled && module_type !== 'module_12'))?isDisabled:false">Next</v-btn>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import StepperComponentMixin from "../../mixins/StepperComponentMixin";

export default {
    name: "DialogShowPackagesRate",
    mixins: [StepperComponentMixin],
    data      : () => ({
        single_day_type: "morning",
        isDisabled: true,
    }),
    watch     : {
        single_day_type(newVal){
            if(((this.module_type_enabled && (this.module_type == 'module_12' || this.module_type == 'module_9' || this.module_type=='module_6')) || this.frontend_view_folder === 'frontend.skigd') && newVal!=="morning"){
                this.isDisabled = false;
            }
        }
    },
    computed: {
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        module_type_enabled() {
            return this.$store.state.resources.config.module_type_enabled;
        },
        module_type() {
            return this.$store.state.resources.config.module_type;
        },
    },
    methods   : {
        async Next() {
            this.$store.commit('set_single_day_reservation', this.single_day_type);
            this.$emit('modal-close');
            if(this.module_type_enabled && this.module_type == 'module_12'){
                await this.moveToStep(2);
            }else{
                await this.moveToStep(3);
            }
        }
    },
}
</script>

<style scoped>

</style>
